//未结算保单列表
export const idNoAuthOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',

		delBtn: false,
		editBtn: false,
		menuAlign: 'center',
		addBtn: false,
		excelBtn: true,
		searchLabelWidth: 150,
		column: [
			{
				label: '产品名称',
				prop: 'sysProductName',
				search: true,
			},
			{
				label: '被保人姓名',
				prop: 'name',
				search: true,
				width: 100,
			},
			{
				label: '身份证号',
				prop: 'idNo',
				search: true,
			},
			{
				label: '被保企业/个人',
				prop: 'unitName',
				search: true,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
			},
			{
				label: '批单号',
				prop: 'endorseNo',
				search: true,
				formatter: ({endorseNo}) => {
					return safe.validatenull(endorseNo) ? '--' : endorseNo
				},
			},
			{
				label: '是否存在异常',
				prop: 'status',
				formatter: ({status}) => {
					let tempHint = '未知'
					switch (status) {
						case 1:
							tempHint = '是'
							break
						case 2:
							tempHint = '否'
							break
						case 0:
							tempHint = '初始状态'
							break
					}
					return tempHint
				},
			},
			{
				label: '错误信息',
				prop: 'errorMsg',
			},
			{
				label: '创建时间',
				prop: 'createdAt',
			},
		],
	}
}
